import { gql } from "@apollo/client";
import { USER_FIELDS } from "../fragments/note.fragments";

export const GET_NOTE_FOR_REVIEW = gql`
  query getNoteForReview($NotesForReviewInput: NotesForReviewInput) {
    getNoteForReview(NotesForReviewInput: $NotesForReviewInput) {
      ...NoteForReviewData
    }
  }
  ${USER_FIELDS}
`;

export const GET_NOTES_FOR_REVIEW = gql`
  query getNotesForReview($NotesForReviewInput: NotesForReviewInput) {
    getNotesForReview(NotesForReviewInput: $NotesForReviewInput) {
      ...NoteForReviewData
    }
  }
  ${USER_FIELDS}
`;
